// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.routeBox {
  min-width: 60px;
  width: 100%;
  height: 95%;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.unselectedRoute {
  border: 2px solid grey;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.1);
}

.unselectedRoute:hover {
  border-color: grey;
  box-shadow: 2px 2px 5px grey;
}

.selectedRoute {
  border: 2px solid #0D47A1;
  /* box-shadow: 6px 6px 12px rgba(13, 71, 161, 0.2); */
}
.d-flex {
  display: flex;
  flex-wrap: nowrap; /* Prevent wrapping */
}
`, "",{"version":3,"sources":["webpack://./src/styles/SelectRoute.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,iBAAiB,EAAE,qBAAqB;AAC1C","sourcesContent":[".routeBox {\r\n  min-width: 60px;\r\n  width: 100%;\r\n  height: 95%;\r\n  border-radius: 8px;\r\n  padding: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.unselectedRoute {\r\n  border: 2px solid grey;\r\n  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.unselectedRoute:hover {\r\n  border-color: grey;\r\n  box-shadow: 2px 2px 5px grey;\r\n}\r\n\r\n.selectedRoute {\r\n  border: 2px solid #0D47A1;\r\n  /* box-shadow: 6px 6px 12px rgba(13, 71, 161, 0.2); */\r\n}\r\n.d-flex {\r\n  display: flex;\r\n  flex-wrap: nowrap; /* Prevent wrapping */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
